import SiteLayout from '@/components/feature/SiteLayout';
import JsonLd from '@/components/feature/JsonLd';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import HeroSection from './components/HeroSection';
import TodayUpdates from './components/TodayUpdates';
import HotDramas from './components/HotDramas';
import CategorySection from './components/CategorySection';
import LatestEpisodes from './components/LatestEpisodes';
import CalendarPreview from './components/CalendarPreview';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料短剧',
    url: 'https://jinghuibt.cn/',
    description: '按连续剧集更新顺序整理追剧日历，提供剧情分集介绍、下一集预告与全季剧情梗概。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jinghuibt.cn/dramas?keyword={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料短剧',
    url: 'https://jinghuibt.cn/',
    email: 'hello@baoliao-duanju.example.com',
    description: '短剧更新追踪内容站，专注连续剧集更新顺序、追剧日历与分集剧情介绍。',
  },
];

export default function Home() {
  useDocumentMeta({
    title: '爆料短剧｜连续剧集更新顺序+追剧日历，分集剧情介绍与下一集预告',
    description:
      '爆料短剧按连续剧集更新顺序整理追剧日历，每集剧情分集介绍标注清楚，下一集预告提前放，全季剧情梗概一拉到底，想按顺序追剧不漏更，直接收藏这份更新追踪表。',
    keywords: '爆料短剧,连续剧集更新顺序,追剧日历,剧情分集介绍,下一集预告,全季剧情梗概',
    path: '/',
    ogType: 'website',
  });

  return (
    <SiteLayout>
      <JsonLd data={homeSchema[0]} />
      <JsonLd data={homeSchema[1]} />
      <HeroSection />
      <TodayUpdates />
      <HotDramas />
      <CategorySection />
      <LatestEpisodes />
      <CalendarPreview />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
    </SiteLayout>
  );
}